module.exports = __webpack_public_path__ + "img/linkedin.58ca468e.png";